import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Close';
import { sortTranslated } from '../shared/util';

const Filters = (props) => {
    let list = JSON.parse(JSON.stringify(props.list));
    list.sort((a, b) => {
        if (!isNaN(a) && !isNaN(b)) {
            let num1 = parseInt(a);
            let num2 = parseInt(b);
            return num1 > num2 ? 1 : -1;
        } else {
            return a > b ? 1 : -1;
        }
    })
    const [name] = useState(props.name);
    const [options] = useState(list);
    const [open, setOpen] = useState(true);

  
    const onSelect = (value, name) => {
        props.onSelect(value, name);
    }

    const deleteItem = (value, name) => {
        props.onSelect(value, name);
        props.deleteItem(name);
    }

    const closeAccordian = () => {
        setOpen(!open);
    }
    return (
        <>

            <Accordion key={name} className=" shadow-md " expanded={open} >

                <AccordionSummary onClick={() => closeAccordian()}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="FirstName"
                >

                    <Typography id="filter-result">
                        <IconButton color="primary" aria-label="upload picture" onClick={() => deleteItem('', name)} >
                            <CancelIcon className='text-danger' style={{ fontSize: 20 }} />
                        </IconButton>
                        {props.label.includes('.')  ? props.label.split('.').join(' ')
                : props.label.includes(' ') ? props.label  : props.label.replace(/([a-z])([A-Z])/g, '$1 $2')
           }
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div className=" container w-100 ">
                        {
                            <Autocomplete
                                multiple={true}
                                limitTags={5}
                                disableCloseOnSelect
                                key={name}
                                onChange={(event, value) => onSelect(value, name)}
                                options={sortTranslated(options)}
                                id={name}
                                name={name}
                                renderInput={(params) =>
                                    <TextField {...params} 
                                    variant="standard"/>}
                            />

                        }

                    </div>
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default Filters;